import { render } from "./sizeModule.vue?vue&type=template&id=7541eba7"
import script from "./sizeModule.vue?vue&type=script&lang=js"
export * from "./sizeModule.vue?vue&type=script&lang=js"

import "./sizeModule.vue?vue&type=style&index=0&id=7541eba7&lang=css"
script.render = render

export default script